// ported from https://github.com/github/blackbird-mw/blob/main/internal/parser/glob.go d377d9d

export function isPossibleGlobExpression(input: string): boolean {
  return input.includes('?') || input.includes('*')
}

export function convertGlobToRegex(input: string): string {
  let output = ''

  if (input.startsWith('/')) {
    input = input.substring(1)
    output += '^'
  }

  const chArray = Array.from(input)
  for (let idx = 0; idx < chArray.length; idx++) {
    const ch = chArray[idx]
    if (ch === '?') {
      output += '.'
    } else if (ch === '*') {
      // Note: since '*' is a single byte, we don't have to decode a whole rune
      if (idx + 1 < chArray.length && chArray[idx + 1] === '*') {
        idx++
        output += '.*'
      } else {
        output += '[^/]*'
      }
    } else if (ch === '\\') {
      if (
        idx + 1 < chArray.length &&
        (chArray[idx + 1] === '?' || chArray[idx + 1] === '*' || chArray[idx + 1] === '\\')
      ) {
        output += escapeForRegexp(chArray[idx + 1])
        idx++
      } else {
        output += escapeForRegexp(ch)
      }
    } else {
      output += escapeForRegexp(ch)
    }
  }

  output += '$'
  return output
}

export function escapeForRegexp(input: string) {
  return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
